import queryString from 'query-string';
const API_URL = process.env.REACT_APP_SERVER_API_URL;

export const getfetchSupportCurrencies = async () => {
  try {
    const response = await fetch(`${API_URL}/api/currencies`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const parsedResult = await response.json();
    if (response.ok) {
      return parsedResult.data;
    }
    throw parsedResult;
  } catch (error) {
    throw error;
  }
};

export const getAllSystemUsers = async ({ queryKey, signal }) => {
  try {
    const [_key, { authToken, params }] = queryKey;
    const url = queryString.stringifyUrl(
      {
        url: `${API_URL}/api/user/all-system-users`,
        query: params,
      },
      { skipNull: true, skipEmptyString: true }
    );
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
      signal,
    });
    const parsedResult = await response.json();
    if (response.ok) {
      return parsedResult.data;
    }
    throw parsedResult;
  } catch (error) {
    throw error;
  }
};
